import React from 'react';

import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import {default as MuiLink} from '@mui/material/Link';
import DiscountIcon from '@mui/icons-material/Discount';
import Link from 'next/link'
import useMediaQuery from '@mui/material/useMediaQuery';
import NarrowContainer from '@/src/common/NarrowContainer';


const YellowCouponBanner = ({
  bannerText = 'Because you are our friend',
  coupon,
}) => {
  const theme = useTheme();
  const discountStr = coupon.discountPercentageStr || coupon.discountAmountStr;
  return (
    <Box
      width={1}
      height={'100%'}
      data-aos={'flip-left'}
      padding="12px 20px 0px 20px"
      marginTop='-7px'
      sx={{backgroundColor: 'yellow'}}
    >
      <NarrowContainer
        display={'flex'}
        flexDirection={'row'}
        justifyItems={'center'}
        gap={2}
      >
        <Box
          component={Avatar}
          width={50}
          height={50}
          marginBottom={2}
          bgcolor={theme.palette.primary.main}
          color={theme.palette.primary.contrastText}
        >
          <DiscountIcon />
        </Box>
        <Box>
          <Typography
            variant={'h6'}
            color="primary"
            sx={{ fontWeight: 'bold' }}
            align={'left'}
          >
            {discountStr} Off All&nbsp;
            <Link href="/wines?ref=banner"><a><MuiLink component={"span"}>Wine</MuiLink></a></Link>
            &nbsp;&&nbsp;
            <Link href="/spirit?ref=banner"><a><MuiLink component={"span"}>Spirit</MuiLink></a></Link>
          </Typography>
          <Typography align={'left'} color="textSecondary" gutterBottom variant="body2">
            {bannerText}
          </Typography>
        </Box>
      </NarrowContainer>
    </Box>
  )
};

export default YellowCouponBanner;
